import Autoplay from "embla-carousel-autoplay";
import { TypographySM } from "../typography/SM";
import { TypographyXS } from "../typography/XS";
import TooltipHover from "../ui/TooltipHover";
import { Badge } from "../ui/badge";
import Card from "../ui/card";
import { Carousel, CarouselContent, CarouselItem } from "../ui/carousel";

const carouselContent = [
  "Be sure to add only the files and requirements that are necessary to your app. This reduces image size, which in turn improves loading speed.",
  "When you are deploying a new version, the loading time will take longer due to the build and deployment process.",
  "If it has been at least one week since your app has been used, the loading time will take longer due to the app redeploying."
];

export const AdminAdviceCarousel = () => {
  return (
    <Carousel
      opts={{ loop: true }}
      plugins={[
        Autoplay({
          delay: 10000
        })
      ]}
    >
      <CarouselContent>
        {carouselContent.map((_, idx) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <CarouselItem key={idx} className="flex justify-center select-none">
              <Card className="max-w-[600px] w-1/2 p-2">
                <div className="w-full justify-between flex items-center p-2">
                  <TooltipHover
                    placement="right"
                    text="Only organization administrators are shown these tips."
                  >
                    <Badge className="cursor-help" variant="secondary">
                      Application Developer Tips
                    </Badge>
                  </TooltipHover>
                  <TypographyXS>
                    {idx + 1} of {carouselContent.length}
                  </TypographyXS>
                </div>
                <TypographySM className="text-start pt-1 px-2 pb-2">
                  {carouselContent[idx]}
                </TypographySM>
              </Card>
            </CarouselItem>
          );
        })}
      </CarouselContent>
    </Carousel>
  );
};
